import pkg from '../../../package.json';


export default class Footer {

	static selector = 'footer';

	constructor(container) {
		this.el = {
			container,
			version: container.querySelector('.version')
		};

		this.el.container.innerText = `v${pkg.version}`;
	}

}
